//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[[0,"Length",0,0]],[[["objects"],"Append",{},1,0],[["object"],"AppendObject",{},1,0],[["delete_idx"],"ClearIndex",{},1,0],[["obj"],"FindIndex",{R_:{index:''}},1,0],[["index"],"FindItem",{R_:{obj:"TaggedObject"}},1,0],[["index"],"Erase",{},1,0],[["index","delete_option"],"EraseWithDeleteOption",{},2,0],[["obj"],"EraseObject",{},1,0],[["obj","delete_option"],"EraseObjectWithDeleteOption",{},2,0],[[],"Clear",{},0,0],[["delete_option"],"ClearWithDeleteOption",{},1,0],[["num_objects"],"GetContents",{R_:{objects:"TaggedObject[]"}},0,0],[["objects"],"SetContents",{},1,0],[["index1","index2"],"Swap",{},2,0],[["object1","object2"],"SwapObjects",{},2,0],[["location","object"],"Insert",{},2,0],[["index"],"MoveToTop",{},1,0],[["index"],"MoveToBottom",{},1,0]],[]];
SPLM.ObjectList = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ObjectList";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ObjectList.DeleteOption = Object.freeze({
    "Delete" : "Delete", "NoDelete" : "NoDelete"});

export default SPLM;